/**
 * Created by shanie on 11/3/16.
 */
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Tooltip from '../Tooltip';
import { Switch } from 'dibs-elements/exports/Switch';

// Helpers
import classNames from 'classnames';
import { copy, tabs, tooltips } from '../../constants';

// Styles
import styles from './styles/SwitchButton.scss';

const SwitchButton = props => {
    const { containerClass, switchOn, tab } = props;

    const containerClasses = classNames({
        [styles.container]: !containerClass,
        [containerClass]: !!containerClass,
    });

    return (
        <div className={containerClasses}>
            <Switch
                checked={switchOn}
                dataTn={props.dataTn}
                label={props.switchLabel}
                onChange={props.onSwitch}
                onText={props.onText}
                offText={props.offText}
            >
                {props.showTooltip && (
                    <Tooltip
                        copy={
                            tab === tabs.FOLDERS
                                ? copy.tooltips.REARRANGE_FOLDERS
                                : copy.tooltips.REARRANGE_ITEMS
                        }
                        type={tooltips.REARRANGE_ITEMS}
                    />
                )}
            </Switch>
        </div>
    );
};

SwitchButton.defaultProps = {
    dataTn: '',
    onText: 'On',
    offText: 'Off',
    switchOn: false,
    switchLabel: '',
};

SwitchButton.propTypes = {
    containerClass: PropTypes.string,
    dataTn: PropTypes.string.isRequired,
    labelClass: PropTypes.string,
    offText: PropTypes.string,
    onSwitch: PropTypes.func,
    onText: PropTypes.string,
    showTooltip: PropTypes.bool,
    switchOn: PropTypes.bool,
    switchLabel: PropTypes.string,
    tab: PropTypes.string,
};

export default SwitchButton;
